<template>
  <div>
    <form @submit.prevent="submit()">

      <div class="mb-3">
        <SGPFormInputComponent
          type="text"
          name="tratativa"
          v-model="formulario.tratativa"
          placeholder="Tratativa"
          data-vv-as="Tratativa"
          v-validate="'required|min:2'"
          :error="validationErrors.first('tratativa')"
        />
      </div>

      <div class="mb-3">
        <SGPFormInputComponent
          name="observacao"
          type="textarea"
          rows="3"
          placeholder="Observação"
          data-vv-as="Observação"
          :error="validationErrors.first('observacao')"
          v-model="formulario.observacao"
        />
      </div>

      <div class="container-botoes">
        <button
          class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize"
          type="submit"
        >
          {{ tipoFormulario === 'salvar' ? 'Salvar' : 'Atualizar' }}
        </button>
        <button
          class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize"
          type="button"
          @click="fecharModal()"
        >
          Cancelar
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'FormularioTratativaComponent',

  props: {
    tipoFormulario: {
      type: String,
      required: false,
      default: 'salvar'
    },
    tratativa: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },

  data() {
    return {
      formulario: {
        id: this.tratativa?.id,
        tratativa: this.tratativa?.tratativa ?? '',
        observacao: this.tratativa?.observacao ?? ''
      }
    }
  },

  watch: {
    tratativa: {
      deep: true,
      handler(val) {
        this.formulario = {
          id: val?.id,
          tratativa: val?.tratativa ?? '',
          observacao: val?.observacao ?? ''
        }
      }
    }
  },

  methods: {
    ...mapActions('ctrlTratativas', ['salvarTratativa', 'atualizarTratativa']),

    submit() {
      this.$validator.validateAll().then(async (result) => {
        if (!result) return

        if (this.tipoFormulario === 'salvar') {
          const resp = await this.salvarTratativa(this.formulario)
          if (resp) {
            this.$emit('tratativaSalva')
            this.fecharModal()
          }
          return
        }

        const resp = await this.atualizarTratativa(this.formulario)
        if (resp) {
          this.$emit('tratativaSalva')
          this.fecharModal()
        }
      })
    },

    fecharModal() {
      this.$parent.$parent.$parent.$parent.fecharModal()
    }
  }
}
</script>
